// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__UxlTn","disclaimer":"style_disclaimer__jO6sD","address":"style_address__ImkKk"};